import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_PROJECT_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_PROJECT_ANON_API_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);